
namespace TabAurous.SalesOrder {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SalesOrderDialog extends _Ext.TransDialog<SalesOrderRow, any> {

        protected getFormKey() { return SalesOrderForm.formKey; }
        protected getIdProperty() { return SalesOrderRow.idProperty; }
        protected getLocalTextPrefix() { return SalesOrderRow.localTextPrefix; }
        protected getNameProperty() { return SalesOrderRow.nameProperty; }
        protected getService() { return SalesOrderService.baseUrl; }
        protected getDeletePermission() { return SalesOrderRow.deletePermission; }
        protected getInsertPermission() { return SalesOrderRow.insertPermission; }
        protected getUpdatePermission() { return SalesOrderRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new SalesOrderForm(this.idPrefix);
        TaxArray: any[];
        TaxRegistred: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public Closing: boolean;
        //MaxDate: Date;
        //MinDate: Date;
        //ProdctImage of Items
        static image: string;
        constructor() {
            super();

            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.hideCaption(this.form.LedgerName);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            //q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            //  q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            this.form.LedgerName.getGridField().find('.caption').attr('Style', 'display:none');


            //q.setGridEditorHeight(this.form.TaxDetails.element, 150);
            //q.hideEditorToolbar(this.form.TaxDetails.getGridField());


            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: SalesOrderDialog.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });

            // **** Get Party Details using PartyID **** 

            this.form.PartyId.changeSelect2(e => {
                if (this.form.PartyId.value != "") {
                    let PartyDetails: OMS.CustomerRow;
                    OMS.CustomerService.Retrieve({ EntityId: this.form.PartyId.value }, response => { PartyDetails = response.Entity }, { async: false });
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                    this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                    this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                    this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                    this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                    this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                    this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                    this.ExchangeRate = this.form.ExchRate.value;
                    this.form.LedgerName.value = PartyDetails.LedgerName;
                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );

                    if (AddressDetails != null) {
                        this.form.State.value = AddressDetails.StateName;
                        this.form.Country.value = AddressDetails.CountryName;
                        var city = AddressDetails.CityName;
                        let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                            + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                        this.form.Address1.value = address;

                    }
                    this.form.GrossAmount.value = 0;
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);
                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                });
                //this.form.ItemDetails.itemids = itemids;
                //this.form.ItemDetails.pieces = pieces;
                //this.form.ItemDetails.weight = weight;

            })


            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
            this.validateForm();
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.CustomerGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.CustomerRow[]) => {
                if (selectedItems.length > 0) {

                    this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                    this.form.LedgerName.value = selectedItems[0].LedgerName;

                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                    this.form.LedgerName.value = selectedItems[0].LedgerName;
                    this.RateListId = selectedItems[0].CostPricegroupId == null ? 3 : selectedItems[0].CostPricegroupId;
                    this.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                    this.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                    this.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                    this.StoneDiscount = selectedItems[0].StnAddDisc == null ? 0 : selectedItems[0].StnAddDisc;
                    this.LaborDiscount = selectedItems[0].LbrAddDisc == null ? 0 : selectedItems[0].LbrAddDisc;
                    this.ExchangeRate = this.form.ExchRate.value;
                    this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                    this.form.GstVat.value = selectedItems[0].GstVat;
                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );

                    if (AddressDetails != null) {
                        this.form.State.value = AddressDetails.StateName;
                        this.form.Country.value = AddressDetails.CountryName;
                        var city = AddressDetails.CityName;
                        let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                            + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                        this.form.Address1.value = address;

                    }
                }

            }
            pickerDialog.dialogOpen();

        }


        onDialogClose() {
            this.Closing = true;

        }

        public CalculateAmountandTax(Items: any, TotalItems: number) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ItemTotal: 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;

                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {


                this.form.GrossAmount.value = gramt + TaxAmount;

                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;

                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;

            }


        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0 && this.isNew) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            if (!Q.isEmptyOrNull(this.form.PartyId.value)) {
                q.showAndDisableField(this.form.PartyId);
                q.showAndDisableField(this.form.CurrencyId);
                q.showAndDisableField(this.form.ExchRate);
                let PartyDetails: OMS.CustomerRow;
                OMS.CustomerService.Retrieve({ EntityId: this.form.PartyId.value }, response => { PartyDetails = response.Entity }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
                this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                this.ExchangeRate = this.form.ExchRate.value;
            }

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                reportKey: 'Sales.OrderVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));

            return btns;
        }

        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                var refid = Production.WIPMovementRow.getLookup().items.filter(x => x.OrderId == parseInt(this.form.TransId.value) && x.OrderTypeId == this.form.VoucherTypeId.value)[0];
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);

                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            var refid = Production.WIPMovementRow.getLookup().items.filter(x => x.RefTransId == parseInt(this.form.TransId.value) && x.RefVoucherId == this.form.VoucherTypeId.value)[0];
            if (refid != null) {
                if (refid.MovementId != null || refid.MovementId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        SalesOrderService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }
        validateBeforeSave() {
            let Isvalid = super.validateBeforeSave();
            Isvalid = ValidateTransaction(this.form.ItemDetails.getItems(), this.form.Pieces.value, this.form.Weight.value);
            return Isvalid;
        }
    }
}